import React, { useState, useRef, useEffect } from 'react';

import { Asset } from '../../../app/entities/asset';
import { useTranslation } from 'react-i18next';
import { Widescreen } from '../../../components/icons/Widescreen';

import styles from './AssetViewerImage.module.scss';
interface AssetViewerImageProps {
  asset: Asset;
  src?: string;
}

export const AssetViewerImage: React.FC<AssetViewerImageProps> = ({ asset, src }) => {
  const { t } = useTranslation('moodboard');
  const image = useRef<HTMLImageElement>(null);
  const [imageNotFound, setImageNotFound] = useState(false);

  useEffect(() => {
    setImageNotFound(false);
  }, [src]);

  const handleFullScreen = async () => {
    if (!image.current) {
      return;
    }

    const requestFullscreen =
      image.current.requestFullscreen ||
      // @ts-ignore
      image.current.mozRequestFullScreen ||
      // @ts-ignore
      image.current.webkitEnterFullScreen ||
      // @ts-ignore
      image.current.msRequestFullscreen;

    requestFullscreen.call(image.current);
  };

  // TODO Handle a better loading in the parent component
  return (
    <div className={styles['container']}>
      {src && (
        <div className={styles['moodboard-card-picture']}>
          {!imageNotFound ? (
            <div className={styles['image-layout']}>
              <div className={styles['image-container']}>
                <img
                  ref={image}
                  src={src}
                  alt={asset.name}
                  onError={() => setImageNotFound(true)}
                />
              </div>
            </div>
          ) : (
            <div className={styles['replacement-image']}>
              <p>{t('common:image_not_found')}</p>
            </div>
          )}
        </div>
      )}

      <div className={styles['image-controller']}>
        <div className={styles['icon-box']} onClick={handleFullScreen}>
          <Widescreen />
        </div>
      </div>
    </div>
  );
};
